import { Button } from '@graftcode/design-system'

import { MOBILE_MENU_TEST_IDS } from '@common/common-test-ids.const'
import styles from '@common/components/MobileMenu/MobileMenu.module.scss'

import { ACADEMY_MENU_ROUTES } from '../../academy-mobile-menu.const'
import type { TutorialSection } from '../../types'

type QuickStartListProps = {
  sections: TutorialSection[]
  currentTutorialPath?: string
  onSectionClick: (section: TutorialSection, basePath: string) => void
}

export function QuickStartList({ sections, currentTutorialPath, onSectionClick }: QuickStartListProps) {
  return (
    <div className={styles.academyQuickStartList} data-testid={MOBILE_MENU_TEST_IDS.academyQuickStartList}>
      {sections
        .sort((a, b) => a.order - b.order)
        .map((section) => {
          const isActive = currentTutorialPath === section.path

          return (
            <Button
              key={section.path}
              variant="ghost"
              size="l"
              fullWidth
              text={section.title}
              onClick={() => onSectionClick(section, ACADEMY_MENU_ROUTES.quickStart)}
              className={`${styles.academyArticle} ${isActive ? styles.active : ''}`}
              style={{ justifyContent: 'flex-start' }}
            />
          )
        })}
    </div>
  )
}
